import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/NavBar";
import { useAppDispatch, useAppSelector } from "../store/store";
import AuthAction from "../store/auth/action";
import PostAction from "../store/post/action";
import { FaChevronRight } from "react-icons/fa";

const PRIVACY_URL = "https://arbnorhaxhiu94.github.io/myclothes-terms-conditions";

const ProfilePage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { user, deleteAccountSuccess } = useAppSelector((s) => s.auth);
    const { myPostsData } = useAppSelector((s) => s.post);

    const [showSignOutModal, setShowSignOutModal] = useState(false);
    const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
    const [showDeletePostsModal, setShowDeletePostsModal] = useState(false);

    useEffect(() => {
        if (user?.id) PostAction.getMyPosts(user.id, dispatch);
    }, [user?.id, dispatch]);

    useEffect(() => {
        if (deleteAccountSuccess) {
            setShowDeleteAccountModal(false);
            AuthAction.signOut(dispatch);
        }
    }, [deleteAccountSuccess, dispatch]);

    const onDeleteAccountPress = () => {
        const postCount = myPostsData?.length ?? 0;
        if (postCount > 0) setShowDeletePostsModal(true);
        else setShowDeleteAccountModal(true);
    };

    const onConfirmDeleteAccount = () => {
        if (user?.id) AuthAction.deleteAccount(user.id, dispatch);
    };

    const onSignOut = () => {
        setShowSignOutModal(false);
        AuthAction.signOut(dispatch);
    };

    const navItemClass = "w-full flex items-center justify-between py-3 px-4 rounded-lg hover:bg-gray-50 text-left text-gray-800 font-medium transition";
    const navLinkClass = "w-full flex items-center justify-between py-3 px-4 rounded-lg hover:bg-gray-50 text-gray-800 font-medium transition no-underline";

    return (
        <div className="min-h-screen bg-[#f8f2ed] font-manrope">
            <Navbar />
            <div className="max-w-xl mx-auto px-4 py-6">
                <h1 className="text-2xl font-semibold text-[#704e37] mb-6">Profili im</h1>

                <div className="bg-white rounded-xl shadow p-4 mb-4">
                    <p className="font-medium text-gray-800">{user?.first_name} {user?.last_name}</p>
                    <p className="text-sm text-gray-600">{user?.email}</p>
                    <p className="text-sm text-gray-500 mt-1">
                        Statusi: {user?.status === "approved" ? "Aprovuar" : user?.status === "pending" ? "Në pritje" : "Refuzuar"}
                    </p>
                </div>

                <div className="bg-white rounded-xl shadow overflow-hidden">
                    <Link to="/profile/edit" className={navLinkClass}>
                        <span>Ndrysho profilin</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </Link>
                    <Link to="/profile/password" className={navLinkClass}>
                        <span>Ndrysho fjalëkalimin</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </Link>
                    <Link to="/profile/addresses" className={navLinkClass}>
                        <span>Adresat</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </Link>
                    <Link to="/profile/contacts" className={navLinkClass}>
                        <span>Kontaktet</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </Link>
                    {/* <Link to="/orders" className={navLinkClass}>
                        <span>Porositë</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </Link> */}
                    {/* <Link to="/profile/subscriptions" className={navLinkClass}>
                        <span>Abonimet</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </Link> */}
                    <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className={navLinkClass}>
                        <span>Politikat e privatësisë</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </a>
                    <button type="button" onClick={onDeleteAccountPress} className={navItemClass + " text-red-600 hover:bg-red-50"}>
                        <span>Fshij llogarinë</span>
                        <FaChevronRight className="text-red-500 text-sm" />
                    </button>
                    <button type="button" onClick={() => setShowSignOutModal(true)} className={navItemClass}>
                        <span>Dilni</span>
                        <FaChevronRight className="text-[#704e37] text-sm" />
                    </button>
                </div>
            </div>

            {/* Sign out confirm */}
            {showSignOutModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setShowSignOutModal(false)}>
                    <div className="bg-white rounded-xl shadow-lg max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()}>
                        <p className="font-medium text-gray-800 mb-1">Po dilni?</p>
                        <p className="text-gray-600 text-sm mb-4">A jeni të sigurt që doni të dilni?</p>
                        <div className="flex gap-2">
                            <button onClick={() => setShowSignOutModal(false)} className="flex-1 py-2.5 rounded-lg border border-gray-300 font-medium">Jo</button>
                            <button onClick={onSignOut} className="flex-1 py-2.5 rounded-lg bg-[#704e37] text-white font-medium hover:opacity-90">Po</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete posts first */}
            {showDeletePostsModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setShowDeletePostsModal(false)}>
                    <div className="bg-white rounded-xl shadow-lg max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()}>
                        <p className="font-medium text-gray-800 mb-1">Fshij llogarinë</p>
                        <p className="text-gray-600 text-sm mb-4">Për të fshirë llogarinë së pari duhet të fshini shpalljet tuaja.</p>
                        <div className="flex gap-2">
                            <button onClick={() => setShowDeletePostsModal(false)} className="flex-1 py-2.5 rounded-lg border border-gray-300 font-medium">Mbyll</button>
                            <button onClick={() => { setShowDeletePostsModal(false); navigate("/my-posts"); }} className="flex-1 py-2.5 rounded-lg bg-[#704e37] text-white font-medium hover:opacity-90">Shko te shpalljet</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Confirm delete account */}
            {showDeleteAccountModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setShowDeleteAccountModal(false)}>
                    <div className="bg-white rounded-xl shadow-lg max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()}>
                        <p className="font-medium text-gray-800 mb-1">Po fshini llogarinë?</p>
                        <p className="text-gray-600 text-sm mb-4">Nëse fshini llogarinë, ju nuk do të mund të kyçeni dhe të postoni shpallje më.</p>
                        <div className="flex gap-2">
                            <button onClick={() => setShowDeleteAccountModal(false)} className="flex-1 py-2.5 rounded-lg border border-gray-300 font-medium">Jo</button>
                            <button onClick={onConfirmDeleteAccount} className="flex-1 py-2.5 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700">Po</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfilePage;
